import React from 'react';
import { Descriptions, Modal } from 'antd';
import dayjs from 'dayjs';
import { Massive, MASSIVE_STATUS } from 'services/MassiveService';
import { statusView } from './status';
import { MassiveErrorAlert } from './serviceError';

interface Props {
  open: boolean;
  massive?: Massive;
  error?: unknown;
  onClose: () => void;
}

const formatDate = (value?: string) =>
  value ? dayjs(value).format('DD/MM/YYYY, HH:mm:ss') : '—';

const MassiveAuditModal = ({ open, massive, error, onClose }: Props) => (
  <Modal
    open={open}
    title="Auditoría de la masiva"
    onCancel={onClose}
    onOk={onClose}
    cancelButtonProps={{ style: { display: 'none' } }}
    okText="Cerrar"
  >
    {error ? (
      <MassiveErrorAlert error={error} title="No se pudo cargar la masiva" />
    ) : null}
    {massive ? (
      <Descriptions column={1} size="small" bordered>
        <Descriptions.Item label="Código">
          {massive.massive_id}
        </Descriptions.Item>
        <Descriptions.Item label="Fecha de creación">
          {formatDate(massive.created_at)}
        </Descriptions.Item>
        <Descriptions.Item label="Creada por">
          {massive.uploader_email || '—'}
        </Descriptions.Item>
        <Descriptions.Item label="Estado">
          {statusView(massive.status).label}
        </Descriptions.Item>
        {massive.status === MASSIVE_STATUS.CANCELLED ? (
          <Descriptions.Item label="Eliminada el">
            {formatDate(massive.deleted_at)}
          </Descriptions.Item>
        ) : null}
        {massive.status === MASSIVE_STATUS.CANCELLED ? (
          <Descriptions.Item label="Eliminada por">
            {massive.deleted_by_email || '—'}
          </Descriptions.Item>
        ) : null}
      </Descriptions>
    ) : null}
  </Modal>
);

export default MassiveAuditModal;
